export const PHONECODE = {
  INTERNATIONAL_AU: '1',
  INTERNATIONAL_NZ: '4',
  LOCAL_AU: ['4', '7'],
  LOCAL_NZ: '2',
};
